<template>
  <div class="app-container">
    <!-- <Top></Top> -->

    <!-- 页面头部 -->
    <section class="designers-header">
      <div class="container">
        <h1>全部模型师</h1>
        <p class="header-desc">汇聚全网优秀的3D模型创作者，共{{ totalCount }}位模型师入驻</p>
      </div>
    </section>

    <!-- 模型师列表区 -->
    <section class="designers-section">
      <div class="container">
        <!-- 首次加载骨架屏 -->
        <div v-if="isLoading" class="skeleton-container">
          <div class="skeleton-card" v-for="i in 12" :key="i"></div>
        </div>

        <!-- 模型师列表（懒加载显示） -->
        <div class="designer-list" v-else>
          <div class="designer-card" v-for="(designer, index) in displayedDesigners" :key="designer.userID"
            @click="goDesigner(designer.userID)">
            <img :src="designer.userAvatar || 'http://49.232.163.2:5159/image/30.png'" :alt="designer.userName"
              class="designer-avatar" />
            <h4 class="designer-name">{{ designer.userName }}</h4>
            <p class="designer-style">{{ designer.briefIntroduction || '暂无介绍' }}</p>
            <button class="follow-btn" :class="{ followed: designer.follow }" @click.stop="handleFollowDesigner(index)">
              {{ designer.follow ? "已关注" : "关注" }}
            </button>
          </div>
        </div>

        <!-- 无数据提示 -->
        <div v-if="!isLoading && allDesigners.length === 0" class="no-data">暂无模型师数据</div>

        <!-- 滚动加载中提示 -->
        <div v-if="isAppendLoading" class="loading">加载中...</div>

        <!-- 无更多数据提示 -->
        <div v-if="!hasMore && displayedDesigners.length > 0" class="no-more">已加载全部模型师</div>
      </div>
    </section>

    <!-- 模型师招募区（复用主页样式） -->
    <!-- <section class="recruit-section">
      <div class="container recruit-content">
        <div class="recruit-left">
          <h2>特邀模型师 加入我们</h2>
          <p class="recruit-desc">
            开启职业新征途，已有20000+模型师在此建立品牌，累计带去1亿+销售额
          </p>
          <ul class="recruit-benefits">
            <li class="benefit-item">
              <i class="icon-benefit"></i> 高收益：零门槛上传，尊重原创价值
            </li>
            <li class="benefit-item">
              <i class="icon-benefit"></i> 版权无忧：专业法务团队助力保护
            </li>
            <li class="benefit-item">
              <i class="icon-benefit"></i> 优质客户：覆盖全球500强企业
            </li>
          </ul>
        </div>
        <div class="recruit-right">
          <button class="certify-btn" @click="handleDesignerCertify">
            立即认证模型师
          </button>
        </div>
      </div>
    </section> -->

    <!-- <Bottom></Bottom> -->
  </div>
</template>

<script>
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';

export default {
  name: 'AllDesigners',
  components: {
    Top,
    Bottom
  },
  data() {
    return {
      token: localStorage.getItem('token'),
      allDesigners: [], // 存储全部模型师数据（原始无重复）
      displayedDesigners: [], // 当前显示的模型师列表
      totalCount: 0, // 模型师总数
      isLoading: true, // 首次加载状态
      isAppendLoading: false, // 滚动追加加载状态
      pageSize: 12, // 每次加载数量
      currentBatch: 1, // 当前加载批次
      hasMore: true, // 是否还有更多数据
      scrollDebounceTimer: null, // 滚动防抖计时器
      scrollHandler: null // 滚动事件处理函数引用
    };
  },
  mounted() {
    // 1. 确保页面可滚动（基础配置，无数据修改）
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';
    document.documentElement.style.height = 'auto';
    document.body.style.height = 'auto';

    // 2. 首次加载全部模型师原始数据（无重复）
    this.fetchAllDesigners();

    // 3. 绑定滚动事件（优化事件管理，避免内存泄漏）
    this.$nextTick(() => {
      this.scrollHandler = this.handleScrollLazyLoad.bind(this);
      window.addEventListener('scroll', this.scrollHandler);
    });
  },
  beforeDestroy() {
    // 移除滚动事件监听
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
    clearTimeout(this.scrollDebounceTimer);
  },
  methods: {
    // 获取全部模型师原始数据（无重复）
    async fetchAllDesigners() {
      this.isLoading = true;
      try {
        // 调用获取全部模型师接口（返回原始无重复数据）
        const res = await this.$apiFun.getPopularModelers();
        if (res.status === 200) {
          this.allDesigners = res.obj; // 直接存储原始数据，不做重复追加
          this.totalCount = this.allDesigners.length;
          // 初始化显示第一批数据（无重复）
          this.displayedDesigners = this.getBatchData(1);
          // 准确判断是否有更多数据
          this.hasMore = this.displayedDesigners.length < this.allDesigners.length;
        }
      } catch (err) {
        console.error('获取全部模型师失败:', err);
        this.$message.error('加载模型师数据失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    },

    // 获取指定批次的模型师数据（切片取值，无重复）
    getBatchData(batchNum) {
      const startIndex = (batchNum - 1) * this.pageSize;
      const endIndex = batchNum * this.pageSize;
      // 按索引切片原始数据，确保数据不重复
      return this.allDesigners.slice(startIndex, endIndex);
    },

    // 滚动懒加载处理（防抖，仅触发加载逻辑）
    handleScrollLazyLoad() {
      clearTimeout(this.scrollDebounceTimer);
      this.scrollDebounceTimer = setTimeout(() => {
        // 触发条件：非首次加载、非追加加载中、还有更多数据
        if (!this.isLoading && !this.isAppendLoading && this.hasMore) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
          const clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

          // 滚动至底部50px范围内触发懒加载（门槛合理，不频繁触发）
          const triggerThreshold = 50;
          const isReachBottom = scrollTop + clientHeight >= scrollHeight - triggerThreshold;

          if (isReachBottom) {
            this.appendNextBatch();
          }
        }
      }, 300);
    },

    // 追加加载下一批模型师（无重复，仅加载未显示数据）
    appendNextBatch() {
      // 防重复触发：已在加载中或无更多数据时，不执行
      if (this.isAppendLoading || !this.hasMore) {
        return;
      }

      this.isAppendLoading = true;
      this.currentBatch++;

      // 模拟加载延迟（提升用户体验，无数据修改）
      setTimeout(() => {
        const nextBatchData = this.getBatchData(this.currentBatch); // 获取下一批未显示数据
        // 追加新数据，不重复
        this.displayedDesigners = [...this.displayedDesigners, ...nextBatchData];
        // 更新是否有更多数据（判断是否还有未加载的原始数据）
        this.hasMore = this.displayedDesigners.length < this.allDesigners.length;
        this.isAppendLoading = false;
      }, 500);
    },

    // 跳转到模型师详情页
    goDesigner(designerId) {
      // const routeInfo = this.$router.resolve({
      //   path: '/designer',
      //   query: { id: designerId }
      // });
      // window.open(routeInfo.href, '_blank');
      this.$router.push({
        path: '/designer',
        query: { id: designerId }
      });
    },

    // 关注/取消关注模型师
    async handleFollowDesigner(index) {
      if (!this.token) {
        this.$message.warning('请先登录后再进行关注操作');
        this.$router.push('/login');
        return;
      }

      const designer = this.displayedDesigners[index];
      const isFollow = !designer.follow;

      // 先更新UI状态
      designer.follow = isFollow;

      try {
        const res = await this.$apiFun.getAddMyInterest({
          followedUser: designer.userID
        });

        if (res.status === 200) {
          this.$message.success(isFollow ? '关注成功！' : '取消关注成功！');
          // 同步更新原始数据中的状态，避免切换批次后状态丢失
          const allIndex = this.allDesigners.findIndex(d => d.userID === designer.userID);
          if (allIndex !== -1) {
            this.allDesigners[allIndex].follow = isFollow;
          }
        } else if (res.status === 401 || res.status === 0) {
          this.$message.warning(res.msg);
          this.$router.push('/login');
          return;
        } else {
          throw new Error(res.message || '操作失败');
        }
      } catch (err) {
        console.error('关注操作失败:', err);
        this.$message.error(`${isFollow ? '关注' : '取消关注'}失败：${err.message || '网络异常'}`);
        // 还原UI状态
        designer.follow = !isFollow;
      }
    },

    // 模型师认证跳转
    handleDesignerCertify() {
      if (this.token) {
        this.$router.push('/dashboard/seller/info');
      } else {
        localStorage.removeItem('userData');
        localStorage.removeItem('token');
        this.$router.push('/login');
      }
    }
  }
};
</script>

<style lang="less" scoped>
// 复用原有主题色
@base-deep: #0f1118;
@base-darker: #080a12;
@primary: #0ea5e9;
@primary-light: #38bdf8;
@accent: #7c3aed;
@text-primary: #fff;
@text-secondary: #94a3b8;
@border-color: rgba(148, 163, 184, 0.1);
@skeleton-bg: rgba(30, 41, 59, 0.5);

/* 全局容器 */
.app-container {
  background-color: @base-deep;
  color: @text-primary;
  min-height: 100vh;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 15px;
  overflow: visible;
  box-sizing: border-box;
}

// 确保页面可滚动
:deep(html),
:deep(body) {
  overflow: auto !important;
  height: auto !important;
  margin: 0;
  padding: 0;
}

.container {
  width: 100%;
  max-width: 1785px;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

/* 页面头部 */
.designers-header {
  background-color: @base-darker;
  padding: 2rem 0;
  margin: 0 0 2rem;
  box-shadow: 0 2px 15px rgba(14, 165, 233, 0.1);

  h1 {
    font-size: 2rem;
    color: @text-primary;
    margin-bottom: 0.5rem;
    text-shadow: 0 0 10px rgba(14, 165, 233, 0.2);
  }

  .header-desc {
    color: @text-secondary;
    font-size: 1rem;
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    padding: 1.5rem 0;

    h1 {
      font-size: 1.5rem;
    }

    .header-desc {
      font-size: 0.9rem;
    }
  }
}

/* 模型师列表区 */
.designers-section {
  width: 100%;
  margin: 0 auto 3rem;
  box-sizing: border-box;
  overflow: visible;

  // 骨架屏样式
  .skeleton-container {
    display: flex;
    flex-wrap: wrap;
    gap: clamp(1rem, 2vw, 1.5rem);
  }

  .skeleton-card {
    width: clamp(180px, 100%/5, 200px);
    height: 280px;
    background-color: @skeleton-bg;
    border-radius: 8px;
    animation: skeleton-loading 1.5s infinite alternate;

    @media (max-width: 768px) {
      width: clamp(150px, 45%, 180px);
    }
  }

  @keyframes skeleton-loading {
    0% {
      background-color: @skeleton-bg;
    }

    100% {
      background-color: rgba(45, 65, 94, 0.5);
    }
  }

  // 模型师列表
  .designer-list {
    display: flex;
    gap: clamp(1rem, 2vw, 1.5rem);
    flex-wrap: wrap;
    padding: 1rem 0;
    justify-content: flex-start;
  }

  .designer-card {
    width: clamp(180px, 100%/5, 200px);
    background-color: @base-darker;
    border-radius: 8px;
    padding: 1rem;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    transition: all 0.3s;
    border: 1px solid @border-color;
    cursor: pointer;

    @media (max-width: 1200px) {
      width: clamp(180px, 20%, 200px);
    }

    @media (max-width: 992px) {
      width: clamp(180px, 25%, 200px);
    }

    @media (max-width: 768px) {
      width: clamp(150px, 45%, 180px);
      padding: 0.8rem;
    }

    @media (max-width: 576px) {
      width: clamp(150px, 100%/2 - 10px, 180px);
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 16px rgba(14, 165, 233, 0.15);
      border-color: rgba(14, 165, 233, 0.2);
    }

    .designer-avatar {
      width: 80px;
      height: 80px;
      border-radius: 10%;
      object-fit: cover;
      margin: 0 auto 0.8rem;
      border: 2px solid @primary;
      box-shadow: 0 0 15px rgba(14, 165, 233, 0.2);

      @media (max-width: 768px) {
        width: 60px;
        height: 60px;
      }
    }

    .designer-name {
      font-size: 1.1rem;
      color: @text-primary;
      margin-bottom: 0.3rem;

      @media (max-width: 768px) {
        font-size: 1rem;
      }
    }

    .designer-style {
      color: @text-secondary;
      font-size: 0.9rem;
      margin-bottom: 0.8rem;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      @media (max-width: 768px) {
        font-size: 0.8rem;
      }
    }

    .follow-btn {
      padding: 0.4rem 0.8rem;
      border: 1px solid @primary;
      color: @primary;
      background: transparent;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      @media (max-width: 768px) {
        padding: 0.3rem 0.6rem;
        font-size: 0.8rem;
      }

      &.followed {
        background-color: @primary;
        color: #fff;
        box-shadow: 0 2px 8px rgba(14, 165, 233, 0.3);
      }

      &:hover:not(.followed) {
        background-color: @primary;
        color: #fff;
      }
    }
  }

  // 无数据提示
  .no-data {
    text-align: center;
    padding: 3rem 0;
    color: @text-secondary;
    font-size: 1.2rem;
  }

  // 加载中提示
  .loading {
    text-align: center;
    padding: 2rem 0;
    color: @primary-light;
    font-size: 1rem;
  }

  // 无更多数据提示
  .no-more {
    text-align: center;
    padding: 1rem 0;
    color: @text-secondary;
    font-size: 0.9rem;
  }
}

/* 招募区样式（复用） */
.recruit-section {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: @text-primary;
  padding: 3rem 0;
  position: relative;
  overflow: hidden;
  margin-top: 2rem;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }

  .recruit-content {
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    position: relative;
    z-index: 2;

    @media (max-width: 992px) {
      flex-direction: column;
      text-align: center;
    }

    @media (max-width: 768px) {
      padding: 0 1rem;
    }
  }

  .recruit-left {
    flex: 1;

    h2 {
      font-size: 1.8rem;
      margin-bottom: 1rem;
      text-shadow: 0 0 10px rgba(14, 165, 233, 0.2);
    }

    .recruit-desc {
      font-size: 1.1rem;
      margin: 1rem 0 1.5rem;
      opacity: 0.9;
      line-height: 1.6;
    }

    .recruit-benefits {
      list-style: none;
      padding: 0;

      .benefit-item {
        margin-bottom: 0.8rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding-left: 0.5rem;
        position: relative;

        &::before {
          content: '•';
          color: @primary;
          font-size: 1.5rem;
          position: absolute;
          left: -10px;
        }

        .icon-benefit {
          color: @primary;
        }
      }
    }

    @media (max-width: 992px) {
      width: 100%;

      .recruit-benefits {
        text-align: left;
        display: inline-block;
      }
    }

    @media (max-width: 768px) {
      h2 {
        font-size: 1.5rem;
      }

      .recruit-desc {
        font-size: 1rem;
      }

      .benefit-item {
        font-size: 0.9rem;
      }
    }
  }

  .recruit-right {
    flex-shrink: 0;

    @media (max-width: 992px) {
      width: 100%;
      text-align: center;
    }
  }

  .certify-btn {
    padding: 1rem 2rem;
    background-color: @primary;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 15px rgba(14, 165, 233, 0.3);

    &:hover {
      background-color: @primary-light;
      transform: translateY(-3px);
      box-shadow: 0 6px 20px rgba(14, 165, 233, 0.4);
    }

    @media (max-width: 768px) {
      padding: 0.8rem 1.5rem;
      font-size: 1rem;
    }
  }
}
</style>